import React, { Component } from 'react';
import { Modal, Button, Table } from 'framework-ui-components';
import StatoDichiarazione from 'enums/StatoDichiarazione';
import TipoDichiarazione from 'enums/TipoDichiarazione';

class ModaleNotificaScarto extends Component {
  creaLinkDichiarazione({
    IdDichiarazione, Anno, Tipo, Stato, CodiceUfficio,
  }) {
    const { url730 } = this.props;

    if (IdDichiarazione) {
      if (Stato === 104) {
        const idFornitura = `${Anno}${CodiceUfficio}9${IdDichiarazione.split('/')[1].padStart(11, '0')}`;
        return `${window.config.AuditUrl}/#guest/permalink/${idFornitura}`;
      }
      if (Tipo === TipoDichiarazione.SetteTrentaIntegrativaCodice2) {
        return `${url730}#/SostitutoImposta/Visualizza/${IdDichiarazione.split('/')[1]}`;
      }
      return `${url730}#/Frontespizio/Visualizza/${IdDichiarazione.split('/')[1]}`;
    }
  }

  render() {
    const { onClose, dichiarazioniScartate } = this.props;
    const { Count, Items } = dichiarazioniScartate;

    return (
      <Modal
        show
        onClose={onClose}
        className="modale-scarto"
      >
        <Modal.Header>
          Dichiarazioni scartate
        </Modal.Header>
        <Modal.Body>
          <div className="pannello">
            <svg xmlns="http://www.w3.org/2000/svg" width="83.112" height="85" viewBox="0 0 83.112 85">
              <g id="Group_12907" data-name="Group 12907" transform="translate(-6230 -1402.46)">
                <path id="Path_8073" data-name="Path 8073" d="M41.556,0A41.556,41.556,0,1,1,0,41.556,41.708,41.708,0,0,1,41.556,0Zm0,5.708A35.848,35.848,0,1,0,77.4,41.556,36.057,36.057,0,0,0,41.556,5.708Z" transform="translate(6230 1402.593)" fill="#f32a2a" />
                <text id="_" data-name="!" transform="translate(6261.934 1469.46)" fill="#f32a2a" font-size="70" font-family="Roboto-Bold, Roboto" font-weight="700"><tspan x="0" y="0">!</tspan></text>
              </g>
            </svg>
            <div>
              <div className="titolo">
                {
                  Count !== 1 ? `Sono presenti ${Count} dichiarazioni scartate` : 'E\' presente 1 dichiarazione scartata'
                }
              </div>
              <div className="sottotitolo">
                Ricordati di apportare le modifiche necessarie e/o ristampare la dichiarazione.
              </div>
            </div>
          </div>
          <div className="dettaglio">
            <Table>
              <Table.Head>
                <tr>
                  <th>Dichiarante</th>
                  <th>Motivazione</th>
                  <th>Vai alla dichiarazione</th>
                </tr>
              </Table.Head>
              <Table.Body>
                {
                  Items.map(x => (
                    <tr key={x.Id}>
                      <td>{x.Dichiarante}</td>
                      <td>{StatoDichiarazione.stringify(x.Stato, x.HaErrori)}</td>
                      <td>
                        <a href={this.creaLinkDichiarazione(x)}>
                          {x.Stato === 104 ? 'Vai alla pratica Audit' : 'Vai alla dichiarazione'}
                        </a>
                      </td>
                    </tr>
                  ))
                }
              </Table.Body>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button flat primary onClick={onClose}>HO CAPITO</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ModaleNotificaScarto;
